import { render, staticRenderFns } from "./_category.vue?vue&type=template&id=70e65874&scoped=true&"
import script from "./_category.vue?vue&type=script&lang=js&"
export * from "./_category.vue?vue&type=script&lang=js&"
import style0 from "./_category.vue?vue&type=style&index=0&id=70e65874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e65874",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ViewSwitcher: require('/home/circleci/repo/components/ViewSwitcher.vue').default,Loader: require('/home/circleci/repo/components/Loader.vue').default})
